export const usersGarcesFruit = [
  "68700991c815f0cb867ef09e", // garcesadmin
];

export const usersGarcesFruitHarvest = [
  "65aad604f085355441e9b0fc", // vherrera
  "66fdbf6d3f46ebac3888486f", // pgrau
  "6554cadd543b0aaa9c497f94", // rhaz
  "6772a405c145481205bf7dad", // arivera1
  "6554d1478a0417253eba2127", // rquezada
];

export const isGarcesFruitUser = (userId) => {
  return usersGarcesFruit.includes(userId);
};

export const isGarcesFruitHarvestUser = (userId) => {
  return usersGarcesFruitHarvest.includes(userId);
};
